import ThemeMapEnglish from 'components/core-adoption/builder/ThemeMapEnglish'
import ThemeMapSpanish from 'components/core-adoption/builder/ThemeMapSpanish'
import React, { useState } from 'react'
import { formatSectionId } from 'components/core-adoption/functions/formatSectionId'

export default function ThemeMap({ ...props }) {
	const [language] = useState(props.props.language)
	return (
		<div className="scroll-mt-14" id={formatSectionId(props)}>
			{language === 'spanish' ? <ThemeMapSpanish /> : <ThemeMapEnglish />}
		</div>
	)
}
